<template>
  <div>
    <!-- Modal -->
    <div
        class="modal show fade modal-secondary text-left"
        style="display: block;"
        v-if="show"
    >
      <div class="modal-dialog modal-xl">
        <div class="modal-content">

          <!-- Header -->
          <div class="modal-header">
            <h4 class="modal-title" style="text-transform:capitalize;">
              Details
            </h4>
            <button
                type="button"
                class="close"
                aria-label="Close"
                @click="handleClose"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <!-- Body -->
          <div class="modal-body">
            <div class="card">
              <div
                  class="card-body table-responsive p-0 table-striped table-hover table-bordered"
              >
                <table
                    class="table table-head-fixed table-hover-animation text-nowrap"
                >
                  <thead>
                  <tr>
                    <th>S.no</th>
                    <th>Status</th>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Date</th>
                    <th>Action</th>
                  </tr>
                  </thead>

                  <tbody>
                  <template v-for="(row, index) in list">
                    <!-- Main Row -->
                    <tr :key="'row-' + index">
                      <td>{{ index + 1 }}</td>

                      <td v-if="row.status == 1">
                        <span class="badge badge-light-info badge-glow badge-sm">
                          INITIATED
                        </span>
                        <br>
                        <span
                            v-if="!row.user"
                            class="mt-sm-25 badge badge-light-dark badge-glow badge-sm"
                        >
                          Auto Generated
                        </span>
                      </td>

                      <td v-else-if="row.status == 2">
                        <span class="badge badge-light-danger badge-glow badge-sm">
                          CANCELED
                        </span>
                        <br>
                        <span
                            v-if="!row.user"
                            class="mt-sm-25 badge badge-light-dark badge-glow badge-sm"
                        >
                            Auto Canceled
                          </span>
                      </td>

                      <td v-else-if="row.status == 3">
                          <span class="badge badge-light-success badge-glow badge-sm">
                            DONE
                          </span>
                        <br>
                        <span
                            v-if="!row.user"
                            class="mt-sm-25 badge badge-light-dark badge-glow badge-sm"
                        >
                        Auto Completed
                      </span>
                      </td>

                      <td v-else-if="row.status == 5">
                          <span class="badge badge-light-info badge-glow badge-sm">
                             In Transit
                          </span>
                        <br>
                        <span
                            v-if="!row.user"
                            class="mt-sm-25 badge badge-light-dark badge-glow badge-sm"
                        >
                        Auto Generated
                      </span>
                      </td>

                      <td v-else-if="row.status == 6">
                          <span class="badge badge-light-danger badge-glow badge-sm">
                            Transfer Failed
                          </span>
                        <br>
                        <span
                            v-if="!row.user"
                            class="mt-sm-25 badge badge-light-dark badge-glow badge-sm"
                        >
                        Auto Generated
                      </span>
                      </td>

                      <td v-else>
                      <span class="badge badge-light-warning badge-glow badge-sm">
                        Draft
                      </span>
                                            <span
                                                v-if="!row.user"
                                                class="ml-1 badge badge-light-dark badge-glow badge-sm"
                                            >
                        Auto Generated
                      </span>
                      </td>


                      <td>
                        {{ row.user
                          ? row.user.first_name + ' ' + row.user.last_name
                          : '-' }}
                      </td>

                      <td>{{ row.user?.email ?? '-' }}</td>

                      <td>
                        {{
                          new Date(row.created_at)
                              .toISOString()
                              .slice(0, 16)
                              .replace('T', ' ')
                        }}
                      </td>

                      <td>
                        <button
                            class="btn btn-sm btn-primary"
                            @click="toggleDetails(index)"
                            :disabled="!row.details"
                        >
                          {{ expandedIndex === index ? 'Hide Details' : 'View Details' }}
                        </button>
                      </td>
                    </tr>

                    <!-- Accordion Row -->
                    <tr
                        v-if="expandedIndex === index"
                        :key="'details-' + index"
                    >
                      <td colspan="6" class="bg-light">
                        <div class="json-wrapper">
                          <vue-json-pretty
                              :data="row.details"
                              :showDoubleQuotes="false"
                          />
                        </div>
                      </td>
                    </tr>
                  </template>

                  <tr v-if="list.length === 0">
                    <td colspan="6" class="text-center">
                      No data available
                    </td>
                  </tr>
                  </tbody>

                </table>
              </div>
            </div>
          </div>

          <!-- Footer -->
          <div class="modal-footer justify-content-between">
            <button
                type="button"
                class="btn btn-danger"
                @click="handleClose"
            >
              Close
            </button>
          </div>

        </div>
      </div>
    </div>

    <!-- Backdrop -->
    <div v-if="show" class="modal-backdrop fade show"></div>
  </div>
</template>

<script>
import VueJsonPretty from 'vue-json-pretty'
import 'vue-json-pretty/lib/styles.css'

export default {
  components: {
    VueJsonPretty
  },
  props: ['show', 'data', 'index'],
  data() {
    return {
      list: [],
      loading: false,
      expandedIndex: null
    }
  },
  watch: {
    show(val) {
      this.list = []
      this.expandedIndex = null

      if (val) {
        // this.list = this.data?.filter(item => item.user != null) || []
        this.list = this.data || []
      }
    }
  },
  methods: {
    toggleDetails(index) {
      this.expandedIndex =
          this.expandedIndex === index ? null : index
    },
    handleClose() {
      this.expandedIndex = null
      this.$emit('hide')
    }
  }
}
</script>

<style scoped>
.modal-dialog {
  overflow-y: initial !important;
}

.modal-body {
  height: 70vh;
  overflow-y: auto;
}

/* JSON scroll control */
.json-wrapper {
  max-height: 45vh;
  overflow-y: auto;
  padding: 10px;
}
</style>
